import { computed, onBeforeUnmount, ref } from 'vue';
import AIControlAPI from 'dashboard/api/smarttec/aiControl';

const POLLING_INTERVAL = 15000;

export const useAIControl = () => {
  const status = ref(null);
  const isLoading = ref(false);
  const error = ref(null);

  let pollingTimer = null;
  let requestInProgress = false;

  const automaticSchedule = computed(
    () => Boolean(status.value?.automatic_schedule)
  );

  const manualActivation = computed(
    () => Boolean(status.value?.manual_activation)
  );

  const effectiveActive = computed(
    () => Boolean(status.value?.effective_active)
  );

  const activationSource = computed(
    () => status.value?.activation_source || 'inactive'
  );

  const fetchStatus = async () => {
    if (requestInProgress) return;

    requestInProgress = true;
    isLoading.value = true;
    error.value = null;

    try {
      const response = await AIControlAPI.getStatus();
      status.value = response?.data || null;
    } catch (requestError) {
      error.value = requestError;
    } finally {
      requestInProgress = false;
      isLoading.value = false;
    }
  };

  const setManualActivation = async enabled => {
    isLoading.value = true;
    error.value = null;

    try {
      const response = await AIControlAPI.setManual(enabled);
      status.value = response?.data || null;
      return status.value;
    } catch (requestError) {
      error.value = requestError;
      throw requestError;
    } finally {
      isLoading.value = false;
    }
  };

  const stopMonitoring = () => {
    if (pollingTimer !== null) {
      window.clearInterval(pollingTimer);
      pollingTimer = null;
    }
  };

  const startMonitoring = () => {
    stopMonitoring();
    fetchStatus();

    pollingTimer = window.setInterval(
      fetchStatus,
      POLLING_INTERVAL
    );
  };

  onBeforeUnmount(stopMonitoring);

  return {
    status,
    isLoading,
    error,
    automaticSchedule,
    manualActivation,
    effectiveActive,
    activationSource,
    fetchStatus,
    setManualActivation,
    startMonitoring,
    stopMonitoring,
  };
};
